import $ from 'jquery'; //eslint-disable-line import/no-unresolved, import/extensions, import/no-extraneous-dependencies

let $heroChevron = $('.more-info-hover-area');
let $hero = $('.subscribe-hero');
let $guardrail = $('guardrail');
const chevronDistance = $heroChevron.data('distance');
const visibleSectionSelectors = '.page-content-visible .subscribe-hero, .hero-content-visible .subscribe-hero';

$heroChevron.on('click', function () {
    $hero = $(this).closest('.subscribe-hero');
    $('html, body').animate({
        scrollTop: $hero.offset().top + $hero.height() + 5
    }, 800);
});

if (chevronDistance) {
    $guardrail.css('margin-bottom', '128px');
}

export default function getScrollPositionToMoveChevron(identifyHero = false) {
    const $heroSelected = $(visibleSectionSelectors);
    if (identifyHero && $heroSelected.length) {
        $hero = $heroSelected;
        $heroChevron = $hero.find('.more-info-hover-area');
        $guardrail = $hero.find('.guardrail');
    }

    const heroHeight = $hero.height();
    const scrollY = window.pageYOffset;
    let screenHeight = window.innerHeight;
    if (chevronDistance) {
        screenHeight -= chevronDistance;
    }
    const haveWeScrolledPastEndOfHero = scrollY > heroHeight;

    if ($guardrail.length && !haveWeScrolledPastEndOfHero) {
        const guardrailBottom = $guardrail.position().top + $guardrail.innerHeight();
        const screenBottomPosition = scrollY + screenHeight;
        const doesHeroContentFitWithinScreen = (guardrailBottom + $heroChevron.height()) <= screenBottomPosition;

        if (doesHeroContentFitWithinScreen) {
            // Set the scroll arrow to appear at the bottom edge of the screen.
            $heroChevron.css('top', 'auto');
            $heroChevron.css('bottom', Math.max(heroHeight - screenHeight - scrollY, 0));
        } else {
            $heroChevron.css('bottom', 'auto');
            $heroChevron.css('top', guardrailBottom);
        }
    }
}

$(window).on('resize scroll', getScrollPositionToMoveChevron);

$(document).ready(getScrollPositionToMoveChevron);
